<div class="seneca-list-container">

    <!-- Success Message -->
    <mat-card *ngIf="isSubmitted" class="main-container">
      <mat-card-content style="padding: 40px 20px; text-align: center;">
        <mat-icon style="font-size: 56px; height: 56px; width: 56px; color: #4caf50;">check_circle</mat-icon>
        <h2 style="margin-top: 16px; color: #2e7d32;">Wire Transfer Information Submitted</h2>
        <p style="color: #555; font-size: 16px; max-width: 480px; margin: 12px auto 0;">
          Thank you! Your wire transfer details have been received. Our team will review your information and follow up if anything is needed.
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="!isSubmitted" class="main-container">
      <mat-card-content class="main-content">
        <form
          [formGroup]="WTForm"
          class="form-container"
          (ngSubmit)="onSubmit()"
        >
          <h2><strong>Wire Tranfer Information </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Payment Method</mat-label>
                      <input
                        matInput
                        [value]="paymentMethod === 'D' ? 'Direct Deposit' : 'Wire Transfer'"
                        readonly
                      />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Currency</mat-label>
                      <input
                        matInput
                        formControlName="Currency"
                        type="text"
                        maxlength="3"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('Currency')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('Currency')?.hasError('pattern')"> 3-letter code (e.g. CAD)</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Beneficiary</strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Beneficiary Name</mat-label>
                      <input
                        matInput
                        formControlName="BF_Name"
                        type="text"
                        maxlength="100"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Name')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Address</mat-label>
                      <input
                        matInput
                        formControlName="BF_Address"
                        type="text"
                        maxlength="200"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Address')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Address')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Beneficiary Bank </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Name</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Name"
                        type="text"
                        maxlength="250"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Name')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Address</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Address"
                        type="text"
                        maxlength="200"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Address')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Address')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Phone Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Phone"
                        type="tel"
                        maxlength="20"
                      />
                      <mat-icon matSuffix>phone</mat-icon>
                      <mat-hint>Include area code</mat-hint>
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Phone')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Phone')?.hasError('pattern')"> Enter a valid phone number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Account Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Account"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Account')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Account')?.hasError('pattern')"> Invalid account number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Code</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Code"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Code')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Code')?.hasError('pattern')"> Invalid bank code</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Transit Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Transit"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Transit')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Transit')?.hasError('pattern')"> Invalid transit number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>ABA Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_ABA"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_ABA')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_ABA')?.hasError('pattern')"> Invalid ABA number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Swift/Sort Code</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Swift"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Swift')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_Swift')?.hasError('pattern')"> Invalid Swift/Sort code</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>IBAN Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_IBAN"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_IBAN')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('BF_Bank_IBAN')?.hasError('pattern')"> Invalid IBAN</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Intermediary Bank </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Name</mat-label>
                      <input
                        matInput
                        formControlName="IN_Bank_Name"
                        type="text"
                        maxlength="250"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Name')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Address</mat-label>
                      <input
                        matInput
                        formControlName="IN_Bank_Address"
                        type="text"
                        maxlength="200"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Address')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Address')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Account Number</mat-label>
                      <input
                        matInput
                        formControlName="IN_Bank_Account"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Account')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Account')?.hasError('pattern')"> Invalid account number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Swift/Sort Code</mat-label>
                      <input
                        matInput
                        formControlName="IN_Bank_Swift"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Swift')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="WTForm.get('IN_Bank_Swift')?.hasError('pattern')"> Invalid Swift/Sort code</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>
          <div class="actions-box">
            <mat-card-actions>
              <button
                mat-stroked-button
                type="button"
                class="seneca-button red"
                color="primary"
                (click)="goToAgencyList()"
              >
                <span>Cancel</span>
              </button>
              &nbsp;
              <button
                type="submit"
                mat-flat-button
                class="seneca-button"
                color="primary"
                [disabled]="WTForm.invalid || isSubmitting"
              >
                <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span>
              </button>
            </mat-card-actions>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
